import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const SoilManagement = () => {
  return (
    <Box>
      <Typography variant="h3" gutterBottom className="vintage-script-header">
        Soil Management
      </Typography>
      
      <Paper sx={{
        p: 3,
        background: 'transparent',
        border: '2px solid var(--color-border-vintage)',
        borderRadius: 0,
        boxShadow: 'none',
        position: 'relative'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: 'linear-gradient(90deg, var(--color-accent-gold) 0%, transparent 50%, var(--color-accent-gold) 100%)'
        }}></div>
        
        <Typography variant="body1" sx={{
          fontFamily: 'var(--font-serif)',
          color: 'var(--color-ink)',
          lineHeight: 1.6,
          mt: 2
        }}>
          Understand soil composition, pH levels, and nutrient management. 
          Learn how to create the perfect growing environment for your plants 
          and maintain soil health over time.
        </Typography>
        
        <Typography variant="body1" sx={{
          fontFamily: 'var(--font-serif)',
          color: 'var(--color-ink)',
          lineHeight: 1.6,
          mt: 2
        }}>
          Explore how Agritur's soil management tools help you track soil types, 
          monitor composition changes, and make informed decisions about 
          amendments and treatments.
        </Typography>
      </Paper>
    </Box>
  );
};

export default SoilManagement;
